import React from 'react';
import PropTypes from 'prop-types';
import { Header, Icon } from 'semantic-ui-react';

const style = {
  width: '100%',
  paddingTop: 20,
  paddingBottom: 20,
  color: 'gray',
};

export default function EmptyState({
  name,
}) {
  return (
    <Header as="h4" icon style={style}>
      <Icon name="clock" color="orange" />
      channel demographics for {name}<br /> will appear once the campaign is approved <br />
      and the influencer has authorised their data
    </Header>
  );
}


EmptyState.propTypes = {
  name: PropTypes.string.isRequired,
};



/** WEBPACK FOOTER **
 ** ./src/containers/acr-demographics-wrapper/empty-state.js
 **/